import { v4 as uuid } from 'uuid';
import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { CmdbObjectTypeId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type { Action } from '@atlassian/react-sweet-state';
import type { InsightObjectViewState, ContainerProps } from '../../../../common/types/index.tsx';
import { ObjectAvatarService } from '../../../../services/object-avatar/index.tsx';
import { updateObjectState } from '../update-object-state/index.tsx';

type AvatarUpdate = {
	selectedImageFile: File;
	onError?: (arg1: Error) => void;
	onSuccess?: () => void;
	objectTypeId: CmdbObjectTypeId;
};

export const updateObjectAvatar =
	({
		selectedImageFile,
		onSuccess,
		onError,
		objectTypeId,
	}: AvatarUpdate): Action<InsightObjectViewState, ContainerProps> =>
	async ({ getState, dispatch }, { workspaceId, onUpdate, createAnalyticsEvent }) => {
		const { objectDetails } = getState();
		const { editableAttributeTypes } = objectDetails ?? {};
		if (objectDetails && editableAttributeTypes) {
			try {
				const { id: objectId } = objectDetails;

				const formData = new FormData();
				formData.append('avatarUUID', uuid());
				formData.append('rlabs-insight-object-avatar', selectedImageFile);
				formData.append('objectTypeId', objectTypeId);

				const { avatarUUID } = await ObjectAvatarService.uploadAvatar({
					workspaceId,
					body: formData,
				});

				const attachedObjectAvatar = await ObjectAvatarService.attachObjectAvatar({
					workspaceId,
					objectId,
					avatarUUID,
				});

				dispatch(
					updateObjectState({
						avatar: attachedObjectAvatar,
						hasAvatar: true,
					}),
				);

				fireTrackAnalytics(createAnalyticsEvent({}), 'updateObjectIcon succeeded');

				onSuccess?.();
				onUpdate();
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				fireCmdbErrorAnalytics({
					meta: {
						id: 'updateObjectIcon',
						packageName: 'jiraServicedeskInsightObjectDetailsStore',
						teamName: 'falcons',
					},
					error,
				});
				if (onError) {
					onError(error);
				}
			}
		}
	};
